import React, {useState} from 'react'
import { BsStar, BsStarFill } from 'react-icons/bs'
import './Stars.css'

const Stars = ({times}) => {
    let unstar = 4 - times

  return (
    <div className='star-container'>
        {[...Array(times)].map((index) => {
            return (<BsStarFill key={index} id='star-icon'/>);
        })}
        {[...Array(unstar)].map((index) => {
            return (<BsStar key={index} id='star-icon'/>);
        })}
    </div>
  )
}

export default Stars